import { PublicationStatusEnum } from '@ztechapps/common.contract'

export type AssertSlugBeforeActiveInput = {
  /** The status the blog is about to take. */
  status?: string
  /** The blog's current slug. */
  slug?: string | null
  /** The error text shown when the change is refused. */
  message: string
}

/** Throws `Error(message)` when the next status is Active and the blog has no slug. */
export const assertSlugBeforeActive = ({ status, slug, message }: AssertSlugBeforeActiveInput): void => {
  if (status === PublicationStatusEnum.Active && !slug) {
    throw new Error(message)
  }
}
